import { render, staticRenderFns } from "./TaskDialog.vue?vue&type=template&id=af99de12"
import script from "./TaskDialog.vue?vue&type=script&lang=js"
export * from "./TaskDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskDialog.vue?vue&type=style&index=0&id=af99de12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports